import ZaiaImage from "./ZaiaImage";

export default ZaiaImage;